import React from 'react';

import SelectDropdown from 'ui-library/dropdowns/SelectDropdown';
import Menu from 'ui-library/menus/Menu';
import {MenuHeight, MenuWidth} from 'ui-library/menus/MenuConstants';
import Option from 'ui-library/menus/Option';

function getDisplayNameForValue(coerceStartCodonToMethionine: boolean | null): string {
  if (coerceStartCodonToMethionine == null) {
    return 'Keep existing';
  } else if (coerceStartCodonToMethionine) {
    return 'Change to methionine';
  } else {
    return 'Unspecified';
  }
}

interface CoerceStartCodonToMethionineDropdownProps {
  className?: string;
  coerceStartCodonToMethionine: boolean | null;
  onChangeCoerceStartCodonToMethionine: (coerceStartCodonToMethionine: boolean | null) => void;
  disabled?: boolean;
  includeNullOption?: boolean;
}

export default function CoerceStartCodonToMethionineDropdown({
  className,
  coerceStartCodonToMethionine,
  onChangeCoerceStartCodonToMethionine,
  disabled,
  includeNullOption,
}: CoerceStartCodonToMethionineDropdownProps): JSX.Element {
  let options: Array<boolean | null>;
  if (includeNullOption) {
    options = [null, true, false];
  } else {
    options = [true, false];
  }

  return (
    <SelectDropdown
      className={className}
      displayName={getDisplayNameForValue(coerceStartCodonToMethionine)}
      menu={
        <Menu
          scrollable={true}
          value={coerceStartCodonToMethionine}
          height={MenuHeight.MEDIUM}
          width={MenuWidth.LARGE}
        >
          {options.map((value) => (
            <Option key={String(value)} value={value} onSelect={onChangeCoerceStartCodonToMethionine}>
              {getDisplayNameForValue(value)}
            </Option>
          ))}
        </Menu>
      }
      disabled={disabled}
    />
  );
}
